import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SBDetailsPageActionButtons from '../components/SBDraftDetailsPageActions';
import SBCreditNoteForm from '../../selfBilledCreditNotes/components/SBCreditNoteForm';
import { useGetCreditNoteHandler } from '../../creditNotes/dataHandlers/getCreditNoteHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function SBDraftCreditNoteDetailsPage() {
  useDocumentTitle('Self Billed Credit Note Details');
  const { document_id } = useParams();
  const navigate = useNavigate();

  const { creditNote, isLoading } = useGetCreditNoteHandler(document_id);
  if (isLoading || !creditNote) {
    return <DocumentSkeletonForm />;
  }

  const handleBack = () => {
    navigate('/self-billed-drafts?tab=creditNotes');
  };

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box sx={{ pb: 4 }}>
        <TopBar title="Credit Note Details" data={creditNote}>
          <SBDetailsPageActionButtons onBack={handleBack} />
        </TopBar>
      </Box>
      <SBCreditNoteForm onSubmit={() => {}} onCancel={() => {}} initialData={creditNote} readOnly={true} />
    </Stack>
  );
}
